import { useTranslation } from 'react-i18next';
import { DashboardMode, IDashboard } from '.';
import InfoCard from '../../../components/organisms/dashboard/info-card';
import classNames from 'classnames';
import { useRouteLoaderData } from 'react-router-dom';
import { IUser } from '../../../services/User.service';
import { useCallback, useEffect, useState } from 'react';
import ContainerService from '../../../services/Container.service';
import { HomeLoaderData } from '../../../types/homeLoaderData';

interface DashboardSimpleProps {
	data: IDashboard;
	mode: DashboardMode;
	carregando: boolean;
}

const DashboardSimple = ({ data, mode, carregando }: DashboardSimpleProps) => {
	const { user } = useRouteLoaderData('home') as HomeLoaderData;
	const { t } = useTranslation();

	return (
		<div
			className={classNames('grid sm:grid-cols-3 gap-y-6 gap-x-3', {
				hidden: mode === 'detailed',
			})}
		>
			<InfoCard
				carregando={carregando}
				className="border-blue"
				title={t('dashboard.monitored_total')}
				value={data.containersTotalMonitored}
				iconClassName="fill-blue h-14"
				icon="Container"
			/>
			<InfoCard
				carregando={carregando}
				className="border-green"
				title={t('dashboard.monitored_no_alerts')}
				value={data.monitored}
				iconClassName="fill-green h-14"
				icon="ContainerRegular"
			/>
			<InfoCard
				carregando={carregando}
				className="border-red"
				title={t('misc.alerts')}
				value={data.alerts}
				iconClassName="fill-red h-14"
				icon="ContainerIrregular"
			/>
			{user.type === 'User' && (
				<InfoCard
					carregando={carregando}
					className="border-yellow"
					title={t('dashboard.available_sockets')}
					value={data.sockets}
					icon="PowerSocket"
					iconClassName="h-14"
				/>
			)}
			<InfoCard
				carregando={carregando}
				className="border-primary"
				title={t('dashboard.frozen')}
				value={data.frozen}
				iconClassName="fill-primary h-14"
				icon="Frozen"
			/>
			<InfoCard
				carregando={carregando}
				className="border-primary-light"
				title={t('dashboard.cold')}
				value={data.cold}
				iconClassName="fill-primary-light h-14"
				icon="Cold"
			/>
			{user.type === 'User' && (
				<InfoCard
					carregando={carregando}
					className="border-purple"
					title={t('dashboard.energy_consumption')}
					value={data.consumption}
					iconClassName="fill-purple h-14"
					icon="Consumption"
				/>
			)}
			{user.type === 'User' && (
				<InfoCard
					carregando={carregando}
					className="border-[#CD0157]"
					title={t('dashboard.efficiency')}
					value={data.efficiency}
					iconClassName="fill-transparent h-14"
					icon="Energy"
				/>
			)}
		</div>
	);
};

export default DashboardSimple;
